// extracted by mini-css-extract-plugin
module.exports = {"menu":"index_menu__cU3KD","active":"index_active__nOZS_"};